var _clipPath, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _image, _image2, _image3, _image4, _image5, _image6, _image7, _image8, _image9, _image10, _image11, _image12, _image13, _image14, _image15, _image16, _image17, _image18, _image19, _image20, _image21, _image22, _image23, _image24, _image25, _image26, _image27, _image28, _image29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasvordachZugstaebe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Glasvordach mit Zugst\\xE4ben",
    transform: "matrix(1,0,0,1,38,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07104,0,0,1.00212,-108.392,-60.2583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCr",
    transform: "matrix(1.15919,0,0,1.29036,149.455,-15.1056)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.551,
    y: 104.174,
    width: 552.046,
    height: 372.519,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.823504,0,0,1.03884,7.01766,-24.0604)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.25164,-1.45151,0,462.458,457.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-89.648,118.742L120.636,118.49L120.636,89.648L-91.794,89.648L-89.648,118.742Z",
    style: {
      fill: "rgb(179,178,178)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44939,-6.92115e-18,5.98671e-18,-1.29862,39.7616,313.178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-235.891L172.722,-235.891L172.968,-24.393L-0,0.13L0,-235.891Z",
    style: {
      fill: "rgb(112,111,111)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.25164,-1.45151,0,210.757,197.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.759,117.805L92.199,117.805L117.805,-54.917L115.659,-83.759L83.759,117.805Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.9655,-9.45584,-10.9658,-9.45564,305.169,189.006)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.284,0.435C0.037,0.188 -0.075,-0.194 0.037,-0.419C0.161,-0.632 0.453,-0.61 0.7,-0.363C0.947,-0.115 1.059,0.266 0.947,0.491C0.932,0.52 0.914,0.545 0.894,0.566C0.756,0.703 0.499,0.65 0.284,0.435Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0367259,-0.0367266,-0.0408928,-0.040892,-10.297,24.1196)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 480.322,
    y: 153.203,
    width: "16.511px",
    height: "22.694px",
    transform: "matrix(0.971244,0,0,0.98668,0,0)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.9654,-9.45568,-10.9656,-9.45548,306.196,188.971)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.281,0.435C0.034,0.188 -0.079,-0.194 0.034,-0.419C0.157,-0.632 0.449,-0.61 0.696,-0.362C0.943,-0.115 1.055,0.266 0.943,0.491C0.929,0.52 0.911,0.545 0.89,0.566C0.753,0.703 0.495,0.65 0.281,0.435Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0367265,-0.0367273,-0.0408935,-0.0408926,-10.3459,24.165)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image5",
    x: 481.582,
    y: 153.203,
    width: "16.511px",
    height: "22.694px",
    transform: "matrix(0.971244,0,0,0.98668,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3e-07,-4.95361,-5.74462,3e-07,316.256,186.112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.96,0.845C0.96,0.974 0.788,1.103 0.574,1.103C0.317,1.103 0.06,0.974 0.016,0.802L0.016,0.716C0.016,0.674 -0.026,-0.612 -0.026,-0.612C0.016,-0.998 0.274,-1.041 0.531,-1.041C0.788,-1.084 0.96,-1.084 0.96,-0.912C0.96,-0.827 0.979,-0.132 0.979,0.361C0.979,0.607 0.974,0.802 0.96,0.845Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.84072,-4.80684,-5.57441,-2.44956,325.712,188.994)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.48,1.31C0.281,1.291 0.037,1.055 0.023,1.071L-0.048,-1.036L0.885,-1.046L0.973,1.208C0.973,1.208 0.779,1.329 0.48,1.31ZM0.023,1.071L0.024,1.077C0.023,1.074 0.023,1.072 0.023,1.071Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0584531,-0.114704,-0.127716,-0.0650838,-7.29654,67.6696)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image8",
    x: 487.857,
    y: 165.55,
    width: "17.949px",
    height: "13.456px",
    transform: "matrix(0.997167,0,0,0.961143,0,0)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.48022,-3.98132,-4.61707,-3.00101,331.797,192.084)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.005,0.101L0.305,-0.58C0.331,-0.614 0.449,-0.631 0.603,-0.622C0.756,-0.614 0.859,-0.536 0.892,-0.511L1.001,0.265L0.005,0.101Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0838534,-0.111245,-0.123864,-0.0933655,-20.6354,71.9535)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 546.026,
    y: 170.083,
    width: "7.341px",
    height: "6.865px",
    transform: "matrix(0.917649,0,0,0.980724,0,0)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.23675,-6.63567,-7.69528,-3.65337,411.924,230.611)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.388,10.045C0.288,10.053 0.201,10.037 0.214,10.012L0.219,-10.051L0.595,-10.036L0.59,10.027C0.576,10.052 0.476,10.061 0.388,10.045Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0442223,-0.0803215,-0.089433,-0.0492387,-6.65561,59.2519)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image12",
    x: 507.324,
    y: 172.053,
    width: "193.664px",
    height: "98.035px",
    transform: "matrix(0.99827,0,0,0.990253,0,0)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.46084,2.63683,3.05789,-4.70891,496.998,267.777)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.668,-0.467L1.586,-0.467L1.595,0.485L-0.695,0.466L-0.668,-0.467Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.112287,0.0628773,0.0700099,-0.125025,-98.3191,-10.5715)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 702.052,
    y: 276.403,
    width: "18.956px",
    height: "13.456px",
    transform: "matrix(0.99767,0,0,0.961143,0,0)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.07872,-4.66873,-5.41425,-1.79249,491.441,267.866)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.605,0.599C0.456,0.633 0.337,0.587 0.297,0.571L-0.02,-0.142L0.98,-0.258L0.88,0.477C0.865,0.516 0.755,0.565 0.605,0.599Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0497787,-0.129654,-0.144362,-0.0554255,4.28314,105.754)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image16",
    x: 759.659,
    y: 269.714,
    width: "7.337px",
    height: "6.866px",
    transform: "matrix(0.917183,0,0,0.980909,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.8477,0,0,-5.0425,501.354,277.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.366,1.492C0.072,1.324 -0.013,0.945 -0.013,0.945L-0.013,-1.624L0.998,-1.624L0.998,1.619C0.998,1.619 0.961,1.624 0.9,1.624C0.778,1.624 0.562,1.605 0.366,1.492Z",
    style: {
      fill: "url(#_Linear17)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45151,0,0,-1.25164,498.323,286.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-0.679C3.224,-1.527 7.465,-2.036 9.501,-1.866L10.688,-1.866L10.688,-1.527C10.688,-1.188 9.671,-0.679 7.635,0C4.411,0.848 0.169,1.357 -1.866,1.187C-2.715,1.187 -3.055,1.018 -3.055,0.678L-3.055,0.34C-2.715,0.17 -1.697,-0.17 0,-0.679",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.614,-16.9139,-19.6148,-16.9132,143.015,144.113)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.285,0.46C0.034,0.209 -0.071,-0.188 0.05,-0.406C0.172,-0.641 0.464,-0.625 0.715,-0.374C0.966,-0.123 1.063,0.266 0.95,0.493C0.934,0.525 0.914,0.552 0.892,0.574C0.753,0.713 0.501,0.676 0.285,0.46Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0238003,-0.0238013,-0.0295,-0.0294988,0.512483,4.45297)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image19",
    x: 80.459,
    y: 60.684,
    width: "26.546px",
    height: "31.276px",
    transform: "matrix(0.98318,0,0,0.977382,0,0)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.6181,-16.9169,-19.6183,-16.9168,144.534,144.172)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.289,0.46C0.038,0.209 -0.076,-0.179 0.054,-0.406C0.176,-0.641 0.467,-0.625 0.718,-0.374C0.969,-0.123 1.066,0.266 0.953,0.493C0.937,0.524 0.918,0.552 0.895,0.574C0.757,0.713 0.505,0.676 0.289,0.46Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0237961,-0.0237963,-0.0294939,-0.0294936,0.475352,4.4926)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image21",
    x: 82.191,
    y: 60.684,
    width: "26.546px",
    height: "31.276px",
    transform: "matrix(0.98318,0,0,0.977382,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.87108e-07,-7.59703,-8.81014,3.87108e-07,161.505,138.461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.953,0.829C0.953,0.938 0.773,1.082 0.556,1.082C0.304,1.082 0.015,0.938 -0.021,0.757L-0.021,0.685C-0.021,0.649 -0.057,-0.65 -0.057,-0.65C-0.021,-1.01 0.232,-1.082 0.484,-1.082C0.809,-1.082 0.953,-1.046 0.953,-0.938C0.953,-0.842 0.969,-0.153 0.969,0.339C0.969,0.585 0.965,0.781 0.953,0.829Z",
    style: {
      fill: "url(#_Linear22)",
      fillRule: "nonzero"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.30185,-6.78131,-7.86417,-3.70951,176.117,142.668)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.447,1.456C0.226,1.416 -0.034,1.153 -0.065,1.136L-0.062,-1.086L0.954,-1.096L0.959,1.332C0.959,1.332 0.747,1.498 0.447,1.456Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0499873,-0.0913813,-0.113261,-0.0619558,3.4577,15.9291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image24",
    x: 112.015,
    y: 71.576,
    width: "24.059px",
    height: "15.926px",
    transform: "matrix(0.962376,0,0,0.995364,0,0)"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.52095,-5.94722,-6.89689,-4.76074,185.218,147.211)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.043,0.132L0.333,-0.627C0.328,-0.677 0.457,-0.666 0.614,-0.632C0.771,-0.598 0.878,-0.559 0.884,-0.508L0.974,0.301L-0.043,0.132Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0660463,-0.0825065,-0.102261,-0.0818597,0.471001,17.7029)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image26",
    x: 134.815,
    y: 86.83,
    width: "10.342px",
    height: "8.295px",
    transform: "matrix(0.940217,0,0,0.921649,0,0)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.37882,-3.7499,-4.34869,-2.05126,309.695,203.836)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.474,27.32C0.187,27.309 -0.013,27.274 -0.038,27.186L-0.008,-27.238L0.995,-27.201L0.965,27.224C0.935,27.279 0.76,27.331 0.474,27.32Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0903971,-0.165254,-0.204821,-0.112041,5.87534,59.3163)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image28",
    x: 134.933,
    y: 84.708,
    width: "256.079px",
    height: "115.608px",
    transform: "matrix(0.996415,0,0,0.996623,0,0)"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.85693,3.72668,4.32177,-6.77506,438.604,262.307)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.73,
    y: -0.508,
    width: 2.435,
    height: 1.016
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0912314,0.0501826,0.0621978,-0.113075,-49.0366,2.86827)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image30",
    x: 403.48,
    y: 196.593,
    width: "25.187px",
    height: "15.987px",
    transform: "matrix(0.968744,0,0,0.999184,0,0)"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82888,-7.21578,-8.36801,-2.43936,429.75,262.636)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.619,0.593C0.46,0.615 0.345,0.614 0.323,0.569L-0.038,-0.161L0.975,-0.35L0.881,0.492C0.884,0.498 0.884,0.503 0.882,0.509C0.869,0.546 0.757,0.574 0.619,0.593Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.033851,-0.100133,-0.124108,-0.0419559,11.9879,47.5548)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image32",
    x: 410.073,
    y: 212.072,
    width: "10.344px",
    height: "8.289px",
    transform: "matrix(0.9404,0,0,0.920974,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.96993,0,0,-7.73481,445.027,277.087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.383,1.392C0.1,1.215 0.029,0.896 0.029,0.896L0.029,-1.513L1.021,-1.513L1.021,1.499C1.021,1.499 0.951,1.513 0.849,1.513C0.72,1.513 0.541,1.491 0.383,1.392Z",
    style: {
      fill: "url(#_Linear33)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.87297,0,0,-1.61507,440.52,286.592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.528C3.902,-2.546 9.162,-3.224 11.537,-2.715C12.216,-2.546 12.555,-2.546 12.895,-2.376L12.895,-2.037C12.895,-1.528 11.537,-0.849 8.992,-0.001C5.09,1.018 -0.17,1.696 -2.715,1.357C-3.563,1.187 -4.072,1.018 -4.072,0.678L-4.072,0.339C-3.224,-0.001 -2.376,-0.849 0,-1.528",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.87108e-07,6.6402,7.70053,3.87108e-07,448.784,284.989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.006,-1.733C0.035,-1.94 0.076,-2.064 0.159,-2.064L0.241,-2.064C0.324,-1.857 0.53,-1.651 0.696,-1.073C0.943,-0.124 1.108,1.155 0.984,1.733C0.943,1.898 0.943,1.98 0.902,2.063L0.819,2.063C0.696,2.063 0.53,1.733 0.324,1.114C0.121,0.333 -0.028,-0.672 -0.028,-1.348C-0.028,-1.493 -0.021,-1.624 -0.006,-1.733Z",
    style: {
      fill: "url(#_Linear34)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29036,0,0,1.29036,75.5633,-15.1056)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.4165,-0.273254,0.316888,-1.22145,32.9495,209.684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-230.577,-27.629L2.571,-27.629L3.053,-25.477L-230.095,-25.477L-230.577,-27.629Z",
    style: {
      fill: "rgb(65,138,169)",
      fillRule: "nonzero"
    }
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(670.473,129.336,149.989,-578.152,110.367,261.113)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00132619,0.000296677,0.000367711,-0.00164373,-0.137472,0.316875)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image35",
    x: 39,
    y: 211,
    width: "736px",
    height: "110px"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80206,0.440185,-0.510474,1.55393,437.594,229.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.635,28.126L203.041,28.126L202.439,26.003L-4.19,26.167L-3.635,28.126Z",
    style: {
      fill: "rgb(141,187,212)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.61507,-1.87297,0,246.038,147.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.111,76.86L93.317,76.86L76.69,-91.111L74.654,-91.111L91.111,76.86Z",
    style: {
      fill: "rgb(65,138,169)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29036,0,0,1.29036,75.5633,-15.1056)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.25164,-1.45151,0,445.375,210.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.144,65.153L76.351,65.153L65.152,-74.144L62.946,-74.144L74.144,65.153Z",
    style: {
      fill: "rgb(177,199,209)",
      fillRule: "nonzero"
    }
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(20.6614,-17.8164,-20.6614,-17.8164,141.512,343.573)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.876,0.477C0.73,0.608 0.468,0.561 0.26,0.354C0.022,0.115 -0.07,-0.238 0.068,-0.438C0.076,-0.461 0.099,-0.484 0.137,-0.523C0.284,-0.669 0.522,-0.584 0.729,-0.377C0.96,-0.146 1.099,0.239 0.929,0.423L0.876,0.477Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0225947,-0.0225947,-0.0280046,-0.0280046,6.12046,9.78864)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image37",
    x: 80.459,
    y: 268.039,
    width: "26.546px",
    height: "31.028px",
    transform: "matrix(0.98318,0,0,0.969623,0,0)"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(20.2411,-17.4543,-20.2414,-17.454,143.853,344.379)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.262,0.395C0.019,0.152 -0.075,-0.209 0.066,-0.413C0.208,-0.618 0.506,-0.586 0.749,-0.343C0.985,-0.107 1.071,0.261 0.945,0.466C0.934,0.482 0.922,0.496 0.909,0.509C0.762,0.656 0.486,0.618 0.262,0.395Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0230635,-0.0230639,-0.0285861,-0.0285856,6.21283,10.0726)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image39",
    x: 82.191,
    y: 268.228,
    width: "26.546px",
    height: "31.023px",
    transform: "matrix(0.98318,0,0,0.969461,0,0)"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0852,10.1969,11.8252,-1.79808,194.746,299.72)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.011,-1.173C-0.005,-1.413 0.029,-1.526 0.108,-1.54L0.185,-1.554C0.226,-1.48 0.353,-1.368 0.49,-1.043C0.766,-0.393 0.993,0.588 1.011,1.149C1.022,1.363 1.01,1.445 0.998,1.528L0.92,1.542C0.841,1.556 0.7,1.366 0.532,1.019C0.341,0.57 0.174,-0.037 0.083,-0.554C0.042,-0.786 0.016,-1 0.011,-1.173Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip40)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.013503,0.0765755,0.0949099,-0.016736,-24.6536,-6.56353)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image41",
    x: 119.379,
    y: 249.108,
    width: "40.844px",
    height: "6.799px",
    transform: "matrix(0.996201,0,0,0.971241,0,0)"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.62683,-7.95619,-9.22665,-1.40282,194.968,310.265)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.648,1.674C0.562,1.969 0.438,2.085 0.371,2.073C0.237,2.05 -0.083,1.132 0.005,0.045C0.094,-1.041 0.677,-2.006 0.744,-1.994C0.844,-1.977 0.936,-1.719 0.982,-1.194C1.014,-0.571 0.95,0.233 0.833,0.896C0.78,1.194 0.717,1.463 0.648,1.674Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0173043,-0.0981423,-0.12164,-0.0214474,28.0957,18.9616)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image43",
    x: 119.033,
    y: 244.98,
    width: "40.846px",
    height: "7.928px",
    transform: "matrix(0.996235,0,0,0.990963,0,0)"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.24586,-7.18716,-8.33482,1.07431,173.614,335.431)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005,2.331C1.022,2.444 0.858,2.62 0.634,2.654C0.373,2.693 0.127,2.577 0.062,2.396L0.05,2.322C0.045,2.285 0.038,-2.099 0.038,-2.099C0.019,-2.477 0.269,-2.591 0.53,-2.63C0.749,-2.701 0.952,-2.617 0.974,-2.468C0.974,-2.468 0.988,2.22 1.005,2.331Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0163785,-0.109573,-0.135808,0.0203,39.36,7.06123)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image45",
    x: 92.224,
    y: 270.559,
    width: "47.373px",
    height: "11.807px",
    transform: "matrix(0.986935,0,0,0.983941,0,0)"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.73591,0.937225,1.08688,-6.67071,188.911,320.248)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.01,1.757L0.036,-0.906C0.115,-1.47 0.741,-1.834 0.85,-1.737C0.995,-1.593 1.018,-1.467 1.001,-1.346L1.003,1.858C1.037,1.904 0.785,1.951 0.502,1.912C0.425,1.912 0.355,1.907 0.292,1.898C0.122,1.874 0.011,1.82 -0.01,1.757Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.118357,0.016629,0.0206105,-0.146696,-20.9885,36.0451)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image47",
    x: 139.69,
    y: 249.398,
    width: "11.269px",
    height: "24.886px",
    transform: "matrix(0.939074,0,0,0.995422,0,0)"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.8342,-14.5169,-16.835,-14.5162,468.107,399.212)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.879,0.461C0.747,0.593 0.483,0.536 0.266,0.319C0.02,0.074 -0.065,-0.276 0.058,-0.455L0.134,-0.531C0.275,-0.672 0.492,-0.568 0.709,-0.351C0.936,-0.125 1.096,0.243 0.927,0.413L0.879,0.461Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0277302,-0.0277315,-0.0343713,-0.0343697,-0.271456,23.6302)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image49",
    x: 449.726,
    y: 329.616,
    width: "20.079px",
    height: "25.266px",
    transform: "matrix(0.956161,0,0,0.971764,0,0)"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.327,-14.0792,-16.3274,-14.0789,470.092,399.636)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.258,0.375C0.005,0.123 -0.083,-0.238 0.043,-0.423C0.18,-0.617 0.481,-0.569 0.725,-0.325C0.958,-0.092 1.075,0.259 0.939,0.473C0.929,0.487 0.918,0.5 0.907,0.512C0.766,0.652 0.491,0.609 0.258,0.375Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0285923,-0.028593,-0.035439,-0.0354381,-0.325871,24.4404)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image51",
    x: 443.227,
    y: 327.153,
    width: "20.422px",
    height: "25.449px",
    transform: "matrix(0.972482,0,0,0.978797,0,0)"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0764613,5.89963,6.84169,-0.065933,514.056,364.834)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.002,-1.737C0.047,-1.924 0.092,-2.017 0.186,-2.018L0.325,-2.019C0.373,-1.881 0.515,-1.65 0.66,-1.094C0.949,-0.169 1.01,1.085 0.877,1.69C0.88,1.876 0.834,1.969 0.835,2.016L0.741,2.017C0.602,2.018 0.413,1.695 0.266,1.093C0.067,0.454 -0.045,-0.275 -0.052,-0.926C-0.055,-1.217 -0.038,-1.493 0.002,-1.737Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00152495,0.136452,0.169122,-0.00189007,-52.3737,-64.9442)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image53",
    x: 471.543,
    y: 317.229,
    width: "29.61px",
    height: "5.771px",
    transform: "matrix(0.986993,0,0,0.961777,0,0)"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1145,-5.45039,-6.32073,-0.961042,513.556,371.095)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636,1.913C0.553,2.1 0.488,2.189 0.39,2.172C0.252,2.097 -0.08,1.133 0.02,-0.005C0.169,-1.135 0.601,-2.165 0.699,-2.148C0.845,-2.122 0.932,-1.755 0.966,-1.095C1.014,-0.406 0.987,0.454 0.869,1.124C0.812,1.443 0.735,1.72 0.636,1.913Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0252608,-0.143262,-0.177564,-0.031309,43.217,78.4717)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image55",
    x: 471.543,
    y: 318.534,
    width: "29.61px",
    height: "5.76px",
    transform: "matrix(0.986993,0,0,0.960019,0,0)"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.04389,-6.02607,-6.98833,0.900148,496.188,392.926)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.991,2.361C1.004,2.45 0.846,2.61 0.624,2.643C0.357,2.683 0.07,2.589 0.044,2.411L0.031,2.323C0.024,2.278 0.009,-2.085 0.009,-2.085C-0,-2.448 0.202,-2.614 0.514,-2.66C0.787,-2.656 0.985,-2.549 1.005,-2.416C1.005,-2.416 1.022,2.265 0.991,2.361Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0195218,-0.130689,-0.16198,0.0241958,63.021,52.1839)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image57",
    x: 442.567,
    y: 352.194,
    width: "39.819px",
    height: "10.159px",
    transform: "matrix(0.99547,0,0,0.923508,0,0)"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.48396,0.785707,0.911171,-5.59115,508.64,380.158)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.023,1.783L0.012,-0.908C0.093,-1.485 0.73,-1.836 0.813,-1.726C0.944,-1.61 0.971,-1.459 0.958,-1.363L0.951,1.822C0.986,1.925 0.787,1.945 0.492,1.953C0.252,1.919 -0.037,1.879 -0.023,1.783Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.141209,0.0198437,0.0245949,-0.175019,-74.8746,46.7163)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image59",
    x: 512.428,
    y: 310.974,
    width: "9.242px",
    height: "20.944px",
    transform: "matrix(0.924177,0,0,0.997356,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.87108e-07,6.6402,7.70053,3.87108e-07,448.784,284.989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.006,-1.733C0.035,-1.94 0.076,-2.064 0.159,-2.064L0.241,-2.064C0.324,-1.857 0.53,-1.651 0.696,-1.073C0.943,-0.124 1.108,1.155 0.984,1.733C0.943,1.898 0.943,1.98 0.902,2.063L0.819,2.063C0.696,2.063 0.53,1.733 0.324,1.114C0.121,0.333 -0.028,-0.672 -0.028,-1.348C-0.028,-1.493 -0.021,-1.624 -0.006,-1.733Z",
    style: {
      fill: "url(#_Linear60)",
      fillRule: "nonzero"
    }
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.90802,-6.88925,-7.98935,-2.5076,447.51,292.44)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.369,1.645C0.072,2.134 -0.072,1.764 0.011,0.879C0.095,-0.005 0.351,-1.145 0.635,-1.599C0.897,-2.1 1.053,-1.765 0.97,-0.88C0.902,-0.153 0.716,0.748 0.507,1.324C0.462,1.448 0.416,1.557 0.369,1.645Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0375611,-0.103193,-0.127901,-0.0465543,14.4167,53.0345)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image62",
    x: 394.68,
    y: 234.718,
    width: "33.888px",
    height: "6.739px",
    transform: "matrix(0.996692,0,0,0.962755,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.29036e-07,5.15358,5.97652,1.29036e-07,725.73,352.368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.052,-1.781C0.052,-2.047 0.105,-2.154 0.211,-2.154L0.317,-2.154C0.371,-2.047 0.477,-1.728 0.636,-1.196C0.902,-0.186 1.061,1.143 1.008,1.781L1.008,2.153L0.902,2.153C0.796,2.153 0.636,1.834 0.424,1.196C0.192,0.316 0.041,-0.806 0.041,-1.502C0.041,-1.606 0.045,-1.699 0.052,-1.781Z",
    style: {
      fill: "url(#_Linear63)",
      fillRule: "nonzero"
    }
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.22059,-5.26117,-6.10129,-1.91483,724.552,358.157)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.336,1.674C0.073,2.256 -0.074,1.942 0.014,0.984C0.103,0.027 0.383,-1.173 0.63,-1.709C0.877,-2.244 1.023,-1.93 0.952,-1.018C0.875,-0.185 0.653,0.833 0.434,1.435C0.401,1.525 0.368,1.605 0.336,1.674Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.049181,-0.13513,-0.167484,-0.0609564,15.3169,113.557)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image65",
    x: 705.757,
    y: 348.756,
    width: "27.495px",
    height: "5.051px",
    transform: "matrix(0.981957,0,0,0.841903,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.824709,0,0,1,17.7123,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.800139,0,0,1.33327,-0.868995,-152.716)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.813,
    y: 409.612,
    width: 64.863,
    height: 154.953,
    style: {
      fill: "rgb(179,178,178)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.43426,0,0,1.76565,-705.601,-238.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.414,
    y: 393.406,
    width: 216.703,
    height: 81.616,
    style: {
      fill: "rgb(112,111,111)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "17px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAXCAYAAADtNKTnAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABsElEQVQ4jZ2Uv2rbUBSHvyOrYB1NsejQqUseIFP3LIFmDN3aEugf6DOUbKHQByh0iG3oAySkbaB7ofRROgR5qW3ZMr6ng3VVWbKSOB/8Fonz6ZyrIwkFXy8vT0XkRERQVeI4RlXLdLtdgA+9JDmhhlycnz8QkTMRORYRfKIoKgVeGEURwBfgbS9JFl4SmtkVcFC3Z1mGmZVxzmFmqOox8GiUps96SfLXSxoCz2w2K4urMlU9CILg5yhND3tJ8ic0sw3lBggg5Pm8LK4KVXWv0+n8HqXp09DMlQXrATMQgTzPG90454jj+HEYhr9aOvkv8CwWC8bjcWM8Vd3ZKKkLPMvlkslksiYxMxqSNoHHOVeK/FilxBffJKgynU7XO7nt6W1kWbbqxDm7l8Azn8+bZ9KOAQHVHfIpJM0bm+N3qtAWx1BZtu2onuMW47SztWTTKoTA1Mz0PsWeANgHruurvE0EYDjo7wI/gN3q301k9Vbq1xrxLQ0H/YfAFfDkbgIQCRDhW+Alr16/uS5G+776uAwzd0MMM/fZzI4axzQc9DvAJ+Ad0NaJicj75y9efgT4B6NCU939Li88AAAAAElFTkSuQmCC"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image5",
    width: "17px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAXCAYAAADtNKTnAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABVElEQVQ4jaWUsUrDUBSGv3sSF8HBhg5OLn0AJ0eLS8HBDr5AJ8FnkG4i+ACCg5OvkATcBfEN6lKfQNLRRe65Lr0hTW/StP5wluTcj/8/HI5hqa/5/E5EplEUISLBAu57STKlJvM5m+2JyLOITEIP61DgBbjuJcmvh4i1NrfWTqy1qOpaWWtXCpgA+aIoDkqIqo5CD0JA3+OcGwFvi6I4AohVtR6xlHMO51zwn4icGGM+FkVxES/JjaA2oIgcG2PeV5z4xk3Qao+IHHaK0wZ1zlHG2dZBVUEnXR346jTYTdB/Ddb3xcst3MnBmpNdHATjbOugHGzbntSbm7TVnjQBY+BHVfdDjZ3jAOdArqr9XeMYgCxNB8ArMDDGBC9a29UznpalaR/IgVMPajuTlUrFQy7H4+9ltMw513omK9+fVPXKUFOWphHwCNwATQ6ciNyeDYcPAH9ojoOdiclBhwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,0.01842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image8",
    width: "18px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABzklEQVQokY3SMYsTQRiA4XcTd3L5hrOQ3A9IJVgIWlpYCQqaLQTBnOfvEP0BCoIW2oiggnVEzRWHvWerWMZWrLzZZc0mzmSzY5HdXDZ66sLAfsU8zDtMMB6Pd2NjrhhjMMYwHo8B3gN3e1G0x39+QZLEXkST5znGGOISTNMU4BNwDxj0oqj4K/RlNPIigoggWuO9r4FJkgCMgPvAy14Uzf4IfdjfP4RKTERoNBpUuRUKfAUeAE97UTSpQW/fvPYimjp2+B+GqoYZYyiK4jvwCHjci6IEIHjx/JlvtVp1aA1ui9But5dQBed5/gN4AjwMXg0G3jmLtZYwDI8E2yLoMjuO49opnXM/jymlUErRam1grSVNU7IsKzdn6BUwy6pZ6Ha7dDodzMEBJo43mtv9/jfgVLPZPKGUIgwV3num0ynTyQQ3mzGbueVazIullKKztcXxzU0CgN3hsAlcA24DpwHm8xxrF8nee0Q0Wi8Sq1wtejkH6+9hdzi8DNwBzi3AOdUdzudztNY1rMz++Bu0Ap4vwYsARVFgrcU5S57na5hcOBJaAc+WyVeBhvd+meycRUTeXe9vX/ontAKeBG4BO0Dovcc5W1hrz9zYufn5F81uGAYCE9JVAAAAAElFTkSuQmCC"
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image10",
    width: "8px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAtElEQVQImT2KMW7CMBhGX0KwRcCeEoGEOmbkDEydOEK5SE/Ss8AheoaGydgMtFLKb8uVOhAYnj59eq8AEJHt2bmDc0577wF+gHfgY9L3X5uyLI9N08wXxqCVIqWkU0o74HWy37995vzX5pypZzOWqxVaa8qiYBiGlyr4sBYR4oixlrZtscZgrKW6XAIS71LiiAjWGrquo1JK8X293gOJ48rzV3U9ZzpV3G6/hOCJ8RFGJMrpH9E5aPEgQ2/PAAAAAElFTkSuQmCC"
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image12",
    width: "194px",
    height: "99px",
    xlinkHref: "data:image/png;base64,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"
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "19px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB3ElEQVQ4jY3SO28TQRDA8f+dzzp7liip3CBaJKDhM9DfVrxkiUcHXSoakIiSIg006dLykCB0cSQ6wmdApKNAgjQgedeyz5Z398xRJLbPhEBGmmK2+M1DGwFYYy4Zaz+ZbrdurcU5VwI7wNNM6y+cMSKAwWDwQUSu5XmO6XYx1mK6XcbjcQG8ANYzrb//Fzs4+HxbRN6IKEQEEWE0GmGNwRiDsZbRcOiAbWAz0/rnqdjH/f1DETkvIogSqqhzbo4aQ57nQ2ALeJZp3TuBvdt5W1aBI7CaiqIoMMbM4H6/b4HnwFam9XCGvX71sgwhLAJKIc0/ahHKslxAe73eD2AT2M609lFnd7d0zuG9wzm3MNFig/lbHMez1Y/hb8BGrd1uHyZJcjVNG8tJkhBCQZ4P8N4RgieEcJQ+ELwnBE9Z/mJp6RytVmvabDmOIh0B7HU6KfAQeAy0plM650jT9MQNq3VThGajgbH26J9NY6/TUcAq8AhY8d7P1q/X66eiTRGUUotYBV05BlcBFUJgetdarTYHKmhT5P1fsQraAp4AD4C0KIrZ+nEcVUAZi8iVf2IV9AKwBtwHapPJHC3LEqXUxvUbN9fOhFXQi8A6cAuIJpMJ3ruvzrnLd+7eG/8GuS8VyB5cicIAAAAASUVORK5CYII="
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image16",
    width: "8px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAjElEQVQImVWNQQ6CMBREH4XkfwIm9lbq1byNhyCRxEuwwR207tqE70IQXUxmknmTKVJKZmbEGD8K4ZuBpRiGwVSVTQAxRl4rVPT93VR2QH7gsiypnuP4X4ii9eqqSzVNEwD7TY2qbKNbdTx6ck7knJnnAMyIyAZenXPuIaK07QHvPU3TYgYxhu50vnRv9ANCMdg5XF8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    id: "_Image19",
    width: "27px",
    height: "32px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACCklEQVRIiZ1WW3KkMAxsDR78v7lcZrO5WZIL7M5mcrDJL48BlA9jLIyMAVdRNA+r1WpbZUI0vm43JiIQEYqigLV2usqyXODT6QQA+PX0RHGseBj5cPv8ZABgZgBA33eoawazu4ZhmO4eW2tRFAW+73fOERoA+H+9MhFNJESAg4S+71FV1YzA3z221uJ8PuP7fuc1leb67y9rJIB/55JommahSmJmRlmWAJBUaVxwHh8liScOuG1blchjr5KIVELDzGpgSSxx13VqKeOyaj4aV0ICESdLGCvtum5VoS9p7KMBeKEqp5SIMAwD6rpO+idJvY/GZx6XbavStm3VUsokvI/GKQmBAw4jp/TxeGxSaDRPNHW60jCn7ztU1ZJIJjF6li7hutL5PObgo7ZwhGepculKdR8d9j7GpRT7zAWQeEmS8zEM76NUmOwgesAtPgalspELz/TAehL5xZJq5FMH0UuYL5cMvKa0aZqUZ9jh4zw5LUk/ZqtR/LqJxOOt6qYFoqlLZXpsWwBqI86pS22LXCMfPQsZaCTLZa+ry3m68Gzb6jvW3gzgTlNa21kv534fp6Oc3G9LkrS6PSuWAODj/W2e03hI9dhNSuNt3wnTYUQjnE88moTAiIYk3UOyCKx9j8nWCI8olUmoZKmy7icJ754vF0qSpQjTPqW/X36/jPQbxlEfX/68zuL/ALqDBfCLxcpTAAAAAElFTkSuQmCC"
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    id: "_Image21",
    width: "27px",
    height: "32px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABXElEQVRIibVXbWrDMAx9Mj7BepeVFdZDd0dp6aCju0F6BGm/bBzFn3JmCBGS0fN7lhWHoMbv8ynOORARwju1tS+Mt8OBdC49VhN+Ho8hoGATURcgAcD3/S4jACXQFku6Xa+7AAW7BuiYGSICZkZqt3zpk/rDeC2LbMBySXue2qJKgC4HZGGqfSISAQOoZ2Y458DMUXttl+IAij69j69lER9opxXVk7S1kDQecvhAu5VghF0p7keTzrDflP5/FQwz98u4R8FUZbRIVosXZbRI1oqvSr9XMiv7uGczB7f3uPha0pmCybFftSsL0Aj7rIzp5NZhHmG/kdHStnrZF7u+5TC32Gc7iPUwtxbqZnrdSJyZ4cMney/JquwB4OtyiXcF/ZVN7dkbWLxu5QCtSYtzoUYK2pu0O67BcixnQLMy9gJa2b0fj1T9EdhrHz9OJwJQZpYDbO2j9n2ez6v8f6ghYoOMYE+GAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-6.61744e-24,0,-1,0,-0.00049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  })), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    id: "_Image24",
    width: "25px",
    height: "16px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABfklEQVQ4jaWUQVLDIBSGfwwlj1U3vY96AHsB9WbqAepCrUfQO/QOXXQGJs0CKLhIISRN09a+mcwwLPjyvv8B896HqqqglYKKn9Zw1iLWw3zOcEWx9XodpJQgIjjnoJRKQK016rq+GsZWq1UgIkhJIGpgnPMWpnWC5nUJkP3+/ATaAyQRaN9VA5aoqgpa606H9kKV7OvzI8QOSBJkto77UkrsnIPqwc5Vyd5eX0L8c9p3Mgxq1pPJJA1IPixjKtn7YhGsNTDGoCiKDNRCE6ins67rA9iQSva9XAYAMMYgwrz3+4NkZyC6OluY974L0xr1dptgPC6EEBBCoCxdgm02G5SlgEwHyqO5TadTzGazA5hWCgwAYjd5ee+z7iyK4qaXWwvt5xZVxivQCWgINqay6SrX2c+yUXl07IaAzrUqrbUQQpyV28mLdExlDmOMjeZ29tNwWqWF97uD3G7v7tm/HrxxlRbWGggh8Pj0zIBshC+peMlyGOccnHOUpU+wWH9SMkpcHq1vOAAAAABJRU5ErkJggg=="
  })), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    id: "_Image26",
    width: "11px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAzUlEQVQYlU2NMY6DQAxFH8IUjLck3eZIm4tv7kGDlYEEKWMXpBhg15Llwu/937CPu29mhplh08SyLMeLn9utAWgAxnHcVBMpKeu6YtPEIUbEKTT3+++mSUmqqCqqCWnlhM2MeZ4BkPzIhAceToQT7iRVhsuFlNK5Zobk/CDCcfcquVdxl76vV/pdkOfzie9QxAHG3haoKsMwVFj1i1Le5JyJqEDs6bWtXlVF+r5HRCjlzev1+gOipp8B4QhA13WItLStUEoh54x7bYh/DR9tcLrENPqYQwAAAABJRU5ErkJggg=="
  })), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    id: "_Image28",
    width: "257px",
    height: "116px",
    xlinkHref: "data:image/png;base64,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"
  })), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    id: "_Image30",
    width: "26px",
    height: "16px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABcUlEQVQ4ja2UQVLCMBSG/5gMvLfkOngG2ak79WTqAcAFXkDugWtckgADJpnGRZs2pQVs9c10kplO+83/5b0IFPW1WgVtDLTWMFpjv98jrZvJROAPVX78fTiEKylhjIFerxGhG2P+BSgA4HO5DMQMJgIxg4iw3WxKWEzpve8NFYvFR2DKf05MIGJwsRIRvPc1mO6pVbzNpiGmYOIKloKJIJUqgRFqOmgVry/PQUpZJCoADeCR1u22kfKSVjGbToNzFtZaZFmWJ2NOYPWk1ftuWsX7fB4AwHuPCLTW5gnjw9wCa9cagcdaVblRCkopDIcEay2cszDGYLfb/U4rEUajUanVJOfpva/mKCZLKwKbWisgJ4rzjm3X2uiSNmBdqwPR8ITW+nikWs/2/zE0y7IkpYOUV0daY2fWu5SIzoO6aq0Ne9RazGOne+uSVuccBoNBdY7FOh5fi943cpvW9Byj1tu7+3yO+oJOAYG61ofHJwEAP3P3Teqty7l0AAAAAElFTkSuQmCC"
  })), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    id: "_Image32",
    width: "11px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAuElEQVQYlVWQOw7DMAxDadhUEDRZcrm291/tJYOCwBLcIZ86WgQBfCShYGZNVbGpQlWh24b+rrXimlBKaSQhIiCJWusBdcB2GqScM0QIUiAkKIJhGDBNE1KMj6RUcgaFEEq3/6AIMc8zlmXpnHsBj0oihwF5QKmUjL7zLT5TrooUIr1eE9wN+75DVRFCuJ2eaUQaxxEA4O5wN5gZzByqClvXO/X9+YZ0/TDGiBgjRAa01uDuJ2j3r3+MY3TzZeA6zgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear33",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-2e-05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear34",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-6.61744e-24,-1.32349e-23,-1,0,-0.00044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(238,237,237)",
      stopOpacity: 1
    }
  })), _image15 || (_image15 = /*#__PURE__*/React.createElement("image", {
    id: "_Image35",
    width: "736px",
    height: "110px",
    xlinkHref: "data:image/png;base64,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"
  })), _image16 || (_image16 = /*#__PURE__*/React.createElement("image", {
    id: "_Image37",
    width: "27px",
    height: "32px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB/0lEQVRIia2WQVqDMBCF30Aa9no5Wz2aegBttXovui4UMi4gkJBJUlrZmI4f8/PeG6YlCNfvz5EBAhGhLEtorVFVFbTW4nmz2Uz3Pjw+ktQTAJT74fj9xQCBGQAYAND3HZqGwcwwxoA5PDMztNYAgFNdcww4wb4OB3YhRBihhL7vcT6fJ4AENcZAa42iKHCqa5ZUKgA47PcMMJgBIsJAJRD5tbZtPTUSVGuNsixFlWr/+cG2uaRqWbtcLlPzmNKqqqCUCoBqeHKrIA5xa13XRa10FS5zVGNQ40UieGknABjj55iylYhwqmtWQ1ZzQwkcU8ps0DRNclKtrUVRwFFmm8cg8+Asa23bJifVKvQyk+2crbOqpFrXddH87Fn5N/mq1g5ObgFMmdkb/Kxmpde8FrkFIGQWszM1ndctgCCzuJ356cwtADWvKVxl5z0LQLnjHKoKIestnheAYmZBlWSnXAsfJr4AlP1amd+hODi0eN0CmDKzTUI71+SYXgBiZuvtvG5wgsxus9NXGpvOILPQzvteC9fiRGapHHN2yoMz2jiE6Nsp1e5TqgAgHJLblObAzu9G1x5XlQy5ZQFMP7Pe317ntkTTX/c8PCHEmv8/t+acXbExYAoiAQOIBEsD85BcLYAtgf9l59N2SyIsBszbKWe23e3GT5nrnhyfX168/n+Kb1IrF7i6qQAAAABJRU5ErkJggg=="
  })), _image17 || (_image17 = /*#__PURE__*/React.createElement("image", {
    id: "_Image39",
    width: "27px",
    height: "32px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABVklEQVRIibVXbW7CMAx9jnqCcZUh0JDGneEkTCAmJrETlCM0++UsdZ3vNBLikbjvYce2XIKyfp9Pa4wBEYGIkMK83jYb0vh4zQ5/Hg8bIvT3NJscQXfwfb9XC0nBkCgBwO16tTXk2nksrPR1uXQVit2jsdbCWotpmtw3f/x9zUZi34bXaxzdD6M9KIVC5CksBU3qH9YKSS9f42hND8Kc8AbDuBZWw9gjdNr+wIDTthX7e9JmSD0IIEnu2wBYCLFNMIyhUmixUbOxtLhzbGYJkkOieZBjk0yQ0KVLzPeVk0SDT86XW0qSixdFvWZxD9xKenuh4rW8iGZjK2GoRfm4S9fPLe7mMJYUtwFQFIqWBuDmr9I+V9NFCADOp9P/hAIUTVElk/NsrvNFuwtJMSlYQxjC79stqXO5FGwV2u33BGDpWUywRujjcHAa0Vec3HvU8OfxuOD+AxkOnCgk8FMuAAAAAElFTkSuQmCC"
  })), _image18 || (_image18 = /*#__PURE__*/React.createElement("image", {
    id: "_Image41",
    width: "41px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAHCAYAAACVxmSwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAf0lEQVQ4ja2SXQrAMAiD1Xj/E2y76vbSHyyxK7QFIdWqH6H63Ncr4aioFlVF0L3O3/I611p685yIiJsZATkJxUDmUFFrhTwLsgs15twMi8PPutM6CNRYdyBzctcd9nXmUO7eAkC/Z05mg3bdCcsZEIvq5NqiNSgAv4szWAAyng/T5QWqexWaZAAAAABJRU5ErkJggg=="
  })), _image19 || (_image19 = /*#__PURE__*/React.createElement("image", {
    id: "_Image43",
    width: "41px",
    height: "8px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAICAYAAABkkNZlAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAbUlEQVQ4jc2UwQnAIBAEd8UKYv9NmFJMG+YvPjY/yUPJQTBGWPBx4Ay3yCMlkYQ1zjmQBIB2t8RythC6g76UYn5otsCZs6ZDzhL4DPKNwC8gnwR8rbXtfjXQKP5eUEmQut1dCzr6DvYY+7QLBC567SJ36ubMcAAAAABJRU5ErkJggg=="
  })), _image20 || (_image20 = /*#__PURE__*/React.createElement("image", {
    id: "_Image45",
    width: "48px",
    height: "12px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAMCAYAAAAkuj5RAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABZElEQVRIicWU0W6DMAxFbeJQ8XHrx3a/xMOYxONKJ2FnD4HghJCUaeosRSFWEo7vNSC8ON5vN3dmf9M0YK3NDrIW8D/hAACMMYeAKWy7zGvOGHOugN8AphA7OCKwbevnBBQRQUSAmcMQYWDeclEBZwER8VCtZ1R1zhXhhBlY5cJ69rOwAJagS/1XsnYdRTAFJ6oIn1N5UQWyAPPs7xJ/D3Vdd6yYtlfNRATGGKXKBvf9eMD9/hUgisA7uC0n4fwMLEmRzKG1sO97l4MHgGhj3eZENWVzqloobtkn6jzzvHvn2g3rQFTP0zS5ADZvaqaq7XMV1XbAmbvXDxExAjyC9ev4v0PDMGR6cFFiVYlTQFZwdZtzQNa2cLloOATEPeBRvF2vuBTwUbB5US2yOYZzzi1QsYpElFXwDNwzQZ/DALOyVUSida7/jCGwNrXbK/jXgNUCxnFUKnkVLRE0bVvtv1cA1uIHjtZyAfywMUQAAAAASUVORK5CYII="
  })), _image21 || (_image21 = /*#__PURE__*/React.createElement("image", {
    id: "_Image47",
    width: "12px",
    height: "25px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAZCAYAAAAFbs/PAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABRklEQVQ4jXWSO5LDMAxDIZF1Gvta8WGz98leINWmomKSW+hjS1Y8o3EjEI+AAgD8PB4OACklvN9/uN1uWJYFy7Lm/7ri9Xrh9/lExOkzU5gZiAhEDGICMYOIkFKCiPQC1XKZ82UmBjPD3ZFSQkrp6sDM7dTpIoIkgs/ng1j5VTMOM4OpTCcCM7fpAA4HM4Oqfue/CsrCzGAeHApSJ1A1hBAO9nJijJA5kk74qfF3SGb2Jf+ysAjcrBeo1kgHB5GGcxKcGj7vQNzxN4Gqwd3LDsf02oHMHGb8uu9dpPdtC9HdoWpz/oKz7/vhkBOaO8iAAwCxe0N1hxN/xekc8rOu04sTXSMtAgVRPPFnhxBC90rv2xYK0tgwtYbHDppDz88dv7tfd5jxy4S/IWV+uiQ0Rlqa9uLAfUKTSAEgdg0X/r0+iSEhAPgHTL8nhwfGBKUAAAAASUVORK5CYII="
  })), _image22 || (_image22 = /*#__PURE__*/React.createElement("image", {
    id: "_Image49",
    width: "21px",
    height: "26px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAaCAYAAABYQRdDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABcklEQVRIiaWVQXLCMAxFv8AQr8vx2qO1PQGl9GBhSSAxVhfBieXIdjrVDAMZ2U/fXyImRPFzPjMRAQA2mw2stbDWomka8W2thTFm2vdyOFDMmTLfpxMzMwCACPDeo+s6eO/Vj7UW+/0eAHBpW47B5ut4fKpjPJki7vd7Fuy9R9M0ICIBNqyRMBYJMQxDFbzdbidwBjpaEKecc7her0XwbrfDpW1ZQCVIql3jc4Cb2UsJKUXqMzOL58XxY7Ul5cPQC9Dj8ZDQeXNZbVrEOacqzjZKBy3De4/b7VY+vgSlypfNC9v7vo+hAMBFRWt9dm5A13H9+LXQfFaglChfP2ohTPyfX2cBgUh/T4R1T6V6Q2qdD2tlESoPfxFVWJcMf17NeuXi1TdbkB+hXBFpwb9HSlUKALoFqfK6BSE33VF/b1i+yHRZfX68z0NBhPHeIhBh8VvPjc8AzVANvATVoUQJVAfroGJOcysGxxtral/f3ggAfgFtf5YdyXaiegAAAABJRU5ErkJggg=="
  })), _image23 || (_image23 = /*#__PURE__*/React.createElement("image", {
    id: "_Image51",
    width: "21px",
    height: "26px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAaCAYAAABYQRdDAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABE0lEQVRIiaWVYW7CMAyFnaecYBxmCKRxZ3YTJjGBxG7AblB7v5w5UYyTNn/q2taX9yxXTWTOz+MhACilRADIxm1Oz9tul6g5JXG/3SQCtbEHTkRE39erjILauAdOX5eLzKjr9eo4FJyZmUSk3GrnFcX6VPDv8ykFOgOyAgAQM5e65oegnpNeHsAYdNaJC90yZxe6Zc4VdEbdqzlX0DXr1IvzsizuikQ2vd6shRH70Tp1oVvU2d4QOqrOPrvQNepsb4HOfIqRk/xKxYy6yr6IEDOHNm1se3tOshbsvkbqPPsVVE+r1LMZzlkTn+ez2OLaXwuAf2gEHr3gfb9PFbQFq+0RdQDocDymyn4E9kD6/nE6FdYfGHDMflzOQawAAAAASUVORK5CYII="
  })), _image24 || (_image24 = /*#__PURE__*/React.createElement("image", {
    id: "_Image53",
    width: "30px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGCAYAAADUtS5UAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAV0lEQVQokWOcN3fOfwYGRgYGBgYGRghFI4BqBwsrKyvZhmCIkuBwFhYWFryGUWI4ki5sFqP6mHiDKYsXFlZWFooNwQYwPYAqwMLHxw9ViJCAsdFpasoBAL5oA4V7HoiPAAAAAElFTkSuQmCC"
  })), _image25 || (_image25 = /*#__PURE__*/React.createElement("image", {
    id: "_Image55",
    width: "30px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGCAYAAADUtS5UAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAXUlEQVQokWO8dvXqfyYmJgZGRkYGUmkYmxggJCzMiMxn+fbtG9kWEkPDwLu3b/+TbDE5oUHIDKwWw9jUcAi6GIzN8vv3b5S4oJuP0RPB////Gf7+/Ys1gVDDQhgNALRzG5Z2vSquAAAAAElFTkSuQmCC"
  })), _image26 || (_image26 = /*#__PURE__*/React.createElement("image", {
    id: "_Image57",
    width: "40px",
    height: "11px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAALCAYAAAANxs/1AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABM0lEQVQ4jb2USW7DMAxFOWhALuEbNYdNz1Rl55WBBggpdSEPkgelbtESEEjZgv/jpyGEP4r32y2dOc/M4JyrlnUO8L8AEHEDsAdU7pn5GPAsAACAtTZ/3HtwU90AcM6BqoKIVFlVQCRnPANijFmESphSdAUWUxpFSwAFFQEZs6rOtYyAOgKaEoCImt3uLUScu1bJQk95wufjsXEjgynIDLDUsvtewHRd14Sx1u6MQGEYhhVYW3QB3UJPdekoEQERA8YYU4yxBti1fW8EdbeH54vGJg0ABGaaQYho3PP4LC8M4SOdHUHbjZxTSk3xaf/yvw8hbBw4cm89ZiIuXMiCl4utwBC/f5O9Xa+bw+YeQiVa1ohYiTMTeO8rVxDpVwCvwvR9D8yL9dY68L4eyZn4CUQrvgAcl9h0gq+DfAAAAABJRU5ErkJggg=="
  })), _image27 || (_image27 = /*#__PURE__*/React.createElement("image", {
    id: "_Image59",
    width: "10px",
    height: "21px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAVCAYAAAB/sn/zAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABBElEQVQokWVS243DMAxjDHKFZqrrsL1leoMEkNBKuQ87jp0YCPxhhi9pAYDf12sHgG3bEPHFY12xPtZ6ryv+3m8UDCciQAkk++fucHeUgy0zkRkQCVGgCDWgmZ2MmVEZSVAEKVCCmVXGURbAJEsSbjYzRmR7FERBDWiHxylIl613RsDNAKAC933vQA0ezR3mfgIzA5lRA1D9BzebGSNa4kP2SNz8TUBJXVaXxBPwWsuyLDB3ZOYIPKuZim5sAFC6v6vskPjn+VxKT6xa9DiRG2Mp5fSncyIHYwdei5YEN8P38xmB2XZwkL2wdUaRw0LwlhgASh3dkFjqy3ok7j3egrRlHc8/qd3XmWw47LAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear60",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-6.61744e-24,-1.32349e-23,-1,0,-0.00044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(238,237,237)",
      stopOpacity: 1
    }
  })), _image28 || (_image28 = /*#__PURE__*/React.createElement("image", {
    id: "_Image62",
    width: "34px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAHCAYAAABtJp9HAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAgElEQVQokb2SUQ6AIAxD2+EJ5P6XwAvogfSfn+mHStRMhITYhJ+tZC9NOY3j6pyDiNzec1biOWeWeu9pLg51McbqQzUecr+/zPOag0ogLZL48ojIK1QHAKoKVQUAkGySRMm/K1SKaAghUZ4i+VtaZoEsKADNemN2KdfkL6iWxd4AGzworb96XEgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear63",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-3.30872e-24,0,-1,0,-0.00043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(238,237,237)",
      stopOpacity: 1
    }
  })), _image29 || (_image29 = /*#__PURE__*/React.createElement("image", {
    id: "_Image65",
    width: "28px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAGCAYAAADQQP5pAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAbElEQVQokZ2RQQ6AIAwER+AF8v9P4BWfhGcSkuIVtdFik172sLPdLnvO3XuPts45s36fNcblIQKh1mqCzAQAOErpGjyICCJCa001fAtgCXGHh/HcET5bqSUAwKXnLaWOMl+GMy2oj7XC/7RwAlPqKe6prKMSAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasvordachZugstaebe);
export default __webpack_public_path__ + "static/media/glasvordach_zugstaebe.bcf9b6cd9587603885748376fa70eee7.svg";
export { ForwardRef as ReactComponent };